import { UploadItem } from '../core/types';
import { formatBytes, formatEta, formatSpeed } from '../core/format';
import { escapeHtml, makeButton, requireElement, statusLabel } from './dom';

export type FileRowAction = 'pause' | 'resume' | 'cancel';

export class FileListView {
  private readonly tbody: HTMLElement;
  private readonly emptyRow: HTMLElement;
  private readonly rows = new Map<string, HTMLTableRowElement>();

  constructor(private readonly onAction: (id: string, action: FileRowAction) => void) {
    this.tbody = requireElement('file-list-body');
    this.emptyRow = requireElement('empty-row');
  }

  upsert(item: UploadItem): void {
    let row = this.rows.get(item.id);
    if (!row) {
      row = document.createElement('tr');
      this.tbody.appendChild(row);
      this.rows.set(item.id, row);
      this.emptyRow.classList.add('hidden');
    }
    this.renderRow(row, item);
  }

  private renderRow(row: HTMLTableRowElement, item: UploadItem): void {
    const percent = item.file.size === 0 ? 100 : Math.min(100, Math.round((item.bytesUploaded / item.file.size) * 100));
    const remaining = Math.max(0, item.file.size - item.bytesUploaded);
    const showSpeed = item.status === 'uploading';

    row.innerHTML = `
      <td class="col-name">${escapeHtml(item.relativePath)}</td>
      <td class="col-size">${formatBytes(item.file.size)}</td>
      <td class="col-progress">
        <div class="row-progress-track"><div class="row-progress-fill" style="width:${percent}%"></div></div>
        ${percent}%
      </td>
      <td class="col-speed">${showSpeed ? formatSpeed(item.speedBps) : '-'}</td>
      <td class="col-eta">${showSpeed ? formatEta(remaining, item.speedBps) : '-'}</td>
      <td class="col-status">
        <span class="status-badge status-${item.status}">${statusLabel(item.status)}</span>
        ${item.error ? `<span class="error-text">${escapeHtml(item.error)}</span>` : ''}
      </td>
      <td class="col-actions"></td>
    `;

    const actionsCell = row.querySelector<HTMLElement>('.col-actions');
    if (!actionsCell) return;

    if (item.status === 'uploading') {
      actionsCell.appendChild(makeButton('일시정지', () => this.onAction(item.id, 'pause')));
    }
    if (item.status === 'paused' || item.status === 'failed') {
      actionsCell.appendChild(makeButton('재개', () => this.onAction(item.id, 'resume')));
    }
    if (item.status !== 'completed' && item.status !== 'cancelled') {
      actionsCell.appendChild(makeButton('취소', () => this.onAction(item.id, 'cancel')));
    }
  }
}
